import { ContextApi } from 'contexts/Localization/types'
import { PageMeta } from './types'

export const DEFAULT_META: PageMeta = {
  title: 'MoonSwap',
  description:
    'The most popular AMM on BSC by user count! Earn MOON through yield farming or win it in the Lottery, then stake it in Syrup Pools to earn more tokens! Initial Farm Offerings (new token launch model pioneered by MoonSwap), NFTs, and more, on a platform you can trust.',
  image: 'https://boltswap.io/images/hero.png',
}

export const getCustomMeta = (path: string, t: ContextApi['t']): PageMeta => {
  let basePath
  if (path.startsWith('/swap')) {
    basePath = '/swap'
  } else if (path.startsWith('/add')) {
    basePath = '/add'
  } else if (path.startsWith('/remove')) {
    basePath = '/remove'
  } else if (path.startsWith('/teams')) {
    basePath = '/teams'
  } else if (path.startsWith('/voting/proposal') && path !== '/voting/proposal/create') {
    basePath = '/voting/proposal'
  } else if (path.startsWith('/nfts/collections')) {
    basePath = '/nfts/collections'
  } else if (path.startsWith('/nfts/profile')) {
    basePath = '/nfts/profile'
  } else {
    basePath = path
  }

  switch (basePath) {
    case '/':
      return {
        title: `MoonSwap`,
      }
    case '/swap':
      return {
        title: `${t('MoonSwap')} - ${t('Swap')}`,
      }
    case '/add':
      return {
        title: `${t('MoonSwap')} - ${t('Add Liquidity')}`,
      }
    case '/remove':
      return {
        title: `${t('MoonSwap')} - ${t('Remove Liquidity')}`,
      }
    case '/liquidity':
      return {
        title: `${t('MoonSwap')} - ${t('Liquidity')}`,
      }
    case '/find':
      return {
        title: `${t('Import Pool')} | ${t('MoonSwap')}`,
      }
    case '/competition':
      return {
        title: `${t('Trading Battle')} | ${t('MoonSwap')}`,
      }
    case '/prediction':
      return {
        title: `${t('Prediction')} | ${t('MoonSwap')}`,
      }
    case '/prediction/leaderboard':
      return {
        title: `${t('Leaderboard')} | ${t('MoonSwap')}`,
      }
    case '/farms':
      return {
        title: `${t('MoonSwap')} - ${t('Farms')}`,
      }
    case '/farms/auction':
      return {
        title: `${t('Farm Auctions')} | ${t('MoonSwap')}`,
      }
    case '/pools':
      return {
        title: `${t('Pools')} | ${t('MoonSwap')}`,
      }
    case '/lottery':
      return {
        title: `${t('Lottery')} | ${t('MoonSwap')}`,
      }
    case '/ifo':
      return {
        title: `${t('Initial Farm Offering')} | ${t('MoonSwap')}`,
      }
    case '/teams':
      return {
        title: `${t('Leaderboard')} | ${t('MoonSwap')}`,
      }
    case '/voting':
      return {
        title: `${t('Voting')} | ${t('MoonSwap')}`,
      }
    case '/voting/proposal':
      return {
        title: `${t('Proposals')} | ${t('MoonSwap')}`,
      }
    case '/voting/proposal/create':
      return {
        title: `${t('Make a Proposal')} | ${t('MoonSwap')}`,
      }
    case '/info':
      return {
        title: `${t('Overview')} | ${t('MoonSwap Info & Analytics')}`,
        description: 'View statistics for MoonSwap exchanges.',
      }
    case '/info/pools':
      return {
        title: `${t('Pools')} | ${t('MoonSwap Info & Analytics')}`,
        description: 'View statistics for MoonSwap exchanges.',
      }
    case '/info/tokens':
      return {
        title: `${t('Tokens')} | ${t('MoonSwap Info & Analytics')}`,
        description: 'View statistics for MoonSwap exchanges.',
      }
    case '/nfts':
      return {
        title: `${t('Overview')} | ${t('MoonSwap')}`,
      }
    case '/nfts/collections':
      return {
        title: `${t('Collections')} | ${t('MoonSwap')}`,
      }
    case '/nfts/profile':
      return {
        title: `${t('Your Profile')} | ${t('MoonSwap')}`,
      }
    default:
      return null
  }
}
